
import {throwError as observableThrowError,  Observable, Subject } from 'rxjs';

import {map} from 'rxjs/operators';
import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { User,UserDto } from "../models/user.model";
import { Login } from "../models/login.model";
import { Token} from "../models/token.model";
import { isPlatformBrowser } from '@angular/common';
import { ToastrService } from '../../../node_modules/ngx-toastr';
import { CurrentUser } from '../models/currentUser.model';
import { Profile } from '../models/profile';

@Injectable()
export class UserService  {
  authKey: string = "auth";
  userKey: string = "currentUser";
  clientId:string = "dwsapp";
  user$:Observable<CurrentUser>;
  private userSubject: Subject<CurrentUser>;

  constructor(
    private http: HttpClient,
    @Inject(PLATFORM_ID) private platformId: any,
    @Inject('BASE_URL') private rootUrl: string,
    private notificationsService: ToastrService,
  ) { 
    this.userSubject = new Subject<CurrentUser>();
    this.user$ = this.userSubject.asObservable();    
  }
  getAll(){
    return this.http.get<UserDto[]>(`${this.rootUrl}/Account/Users`);    
  }
  get(id:string){
    return this.http.get<UserDto>(`${this.rootUrl}/Account/Users/${id}`);    
  }  
  update(id:string, model:User ){
    return this.http.put(`${this.rootUrl}/Account/Users/${id}`,model);    
  }  
  register(user: User) {
    let body: User = {
      email: user.email,
      code: user.code,
      name: user.name,
      firstName: user.firstName,
      familyName: user.familyName,
      idAccount: user.idAccount,
      password: user.password,
      confirmPassword: user.confirmPassword,
      storageType: user.storageType
    }
    return this.http.post(this.rootUrl + '/Account/Register', body);
  }

  login(email:string, password:string){
    let body: Login = {
      clientId: this.clientId,
      grantType: 'password',
      email: email,
      password: password,
      refreshToken:null
    }
    return this.http.post<Token>(this.rootUrl + '/Account/Login', body).pipe(
      map((res)=>{
        if(res){
          if(res.access_token){            
            this.setAuth(res);
            this.currentUser().subscribe((user)=>{
              this.userSubject.next(user);
            });
          }
          return observableThrowError('Unauthorized');
        }
      }));
  }
  loginWithGoogle(email:string,token:string){
    let body: Login = {
      clientId: this.clientId,
      grantType: 'google',
      email: email,
      refreshToken: token,
      password:null
    }
    return this.http.post<Token>(this.rootUrl + '/Account/Login', body).pipe(
      map((res)=>{
        if(res){
          if(res.access_token){
            this.setAuth(res);
          }
          return observableThrowError('Unauthorized');
        }
      }));    
  }
  refreshToken(token:Token){
    let body: Login = {
      clientId: this.clientId,
      grantType: 'refresh_token',
      refreshToken: token.refresh_token
    }    
    return this.http.post<Token>(this.rootUrl + '/Account/Login', body).pipe(
      map((res)=>{
        if(res){
          if(res.access_token){            
            this.setAuth(res);
            this.currentUser().subscribe((user)=>{
              this.userSubject.next(user);
            });
          }
          return observableThrowError('Unauthorized');
        }
      }));
  }
  getMembers():Observable<UserDto[]>{
    return this.http.get<UserDto[]>(`${this.rootUrl}/Account/Members`);
  }
  currentUser():Observable<CurrentUser>{
    if(this.isLoggedIn){
      return this.http.get<CurrentUser>(this.rootUrl + '/Account/User').pipe(
        map((res)=>{
          if(res){
            this.setCurrentUser(res);
            return (<CurrentUser>res);
          }
          else
          {
            observableThrowError('Unauthorized');
            return null;
          }
        }));
    }
  }
  logout(): boolean {
    this.setAuth(null);
    return true;
  }
  setCurrentUser(user:CurrentUser|null):boolean{
    if (isPlatformBrowser(this.platformId)) {
      if (user) {
        localStorage.setItem(
          this.userKey,
          JSON.stringify(user));
      }
      else {
        localStorage.removeItem(this.userKey);
      }
    }
    return true;
  }
  updateProfile(profile:Profile): Observable<any> {
    return this.http.put<Profile>(this.rootUrl + '/Account/User/Profile',profile);
  }
  getCurrentUser(): CurrentUser | null {
    if (isPlatformBrowser(this.platformId)) {
      var i = localStorage.getItem(this.userKey);
      if (i) {
        return JSON.parse(i);
      }
    }
    return null;
  }
  get current():CurrentUser{
    return this.getCurrentUser();
  }
  hasRole(role:string):boolean{
    let user:CurrentUser = this.getCurrentUser();
    if(!user || !user.roles){
      return false;
    }
    return user.roles.includes(role);
  }
  hasAnyRole(roles:string[]):boolean{
    let user:CurrentUser = this.getCurrentUser();    
    if(!user || !user.roles){
      return false;
    }
    let ret:boolean = false;

    if(roles){
      for(let r=0;r<roles.length;r++){
        let role = roles[r];
        ret = user.roles.includes(role);
        if(ret){
          break;
        }        
      }
    }
    return ret;
  }  
  setAuth(auth: Token | null): boolean {
    if (isPlatformBrowser(this.platformId)) {
      if (auth) {
        localStorage.setItem(
          this.authKey,
          JSON.stringify(auth));
      }
      else {
        localStorage.removeItem(this.authKey);
      }
    }
    return true;
  }
  getAuth(): Token | null {
    if (isPlatformBrowser(this.platformId)) {
      var i = localStorage.getItem(this.authKey);
      if (i) {
        return <Token>JSON.parse(i);
      }
    }
    return null;
  }
  isLoggedIn(): boolean {
    if (isPlatformBrowser(this.platformId) && this.currentUser) {
      return localStorage.getItem(this.authKey) != null;
    }
    return false;
  }
}
